import { hideSpinner } from "./loading";
import { getRedirectUrl, getSessionId } from "./utils";

export const showThanks = (shouldRedirect: boolean, customReturnUrl?: string) => {
  const thanks = document.getElementById("thanks");

  thanks?.classList.add("thanks--visible");
  hideSpinner();

  if (shouldRedirect) {
    setTimeout(() => {
      document.getElementById("thanks-image")?.classList.remove("thanks__item--visible");
      document.getElementById("thanks-spinner")?.classList.add("thanks__item--visible");

      document.getElementById("t-t1")?.classList.remove("thanks__item--visible");
      document.getElementById("t-t2")?.classList.remove("thanks__item--visible");
      document.getElementById("t-t3")?.classList.add("thanks__item--visible");
    }, 3000);

    const url = getRedirectUrl(getSessionId(), "success", customReturnUrl);
    window.location.href = url;
  }

  console.log("showing thanks");
};
